export default __webpack_public_path__ + "static/media/JAS0170.34I-43303_-25924_15.75aaea60.jpg";